import { useState } from 'react'
import { OrgCreditLimitCard } from './OrgCreditLimitCard'
import { UserCreditLimitCard } from './UserCreditLimitCard'

export const CreditLimit = () => {
  const [orgCreditLimit, setOrgCreditLimit] = useState<number>(0)

  return (
    <div className="space-y-8" data-testid="credit-limit-page">
      {/* Main Management Section */}
      <div
        className="bg-card border border-border rounded-xl overflow-hidden"
        data-testid="org-credit-limit-section"
      >
        <div className="bg-muted/30 px-6 py-4 border-b border-border">
          <h3
            className="text-lg font-medium"
            data-testid="org-credit-limit-heading"
          >
            Organization Credit Limit
          </h3>
          <p className="text-sm text-muted-foreground">
            Set default credit limits for all users
          </p>
        </div>
        <div className="p-6">
          <OrgCreditLimitCard onLimitChange={setOrgCreditLimit} />
        </div>
      </div>

      {/* User-specific credit limit */}
      <div
        className="bg-card border border-border rounded-xl overflow-hidden"
        data-testid="user-credit-limit-section"
      >
        <div className="bg-muted/30 px-6 py-4 border-b border-border">
          <h3
            className="text-lg font-medium"
            data-testid="user-credit-limit-heading"
          >
            User-Specific Credit Limits
          </h3>
          <p className="text-sm text-muted-foreground">
            Override default limits for specific users
          </p>
        </div>
        <div className="p-6">
          <UserCreditLimitCard orgCreditLimit={orgCreditLimit} />
        </div>
      </div>
    </div>
  )
}
